package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteSummary
import com.milta.feature.route.domain.repository.RouteRepository

class GetMyRoutesUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(date: String? = null): List<RouteSummary> = repository.getMyRoutes(date)
}
